// Single source of truth for "where does this role land after auth?". Accepts
// either the UI role (employee) or the raw backend role (user) — both fall to
// /me. Used by the landing page, LoginPage, and AuthLayout.
export const homePathForRole = (role) =>
  role === "super_admin" ? "/super"
    : role === "admin" ? "/admin"
    : role === "customer" ? "/portal"
    : "/me";
